// Cookie consent utilities for ticket #557
// localStorage shape: { functional: true, analyse: bool, marketing: bool, ts: ms, expires: ms }

export const CONSENT_KEY = "cookie_consent";
export const TWELVE_MONTHS_MS = 12 * 30 * 24 * 60 * 60 * 1000;

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (!parsed.expires || Date.now() > parsed.expires) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent({ analyse = false, marketing = false } = {}) {
  const now = Date.now();
  const consent = {
    functional: true,
    analyse: !!analyse,
    marketing: !!marketing,
    ts: now,
    expires: now + TWELVE_MONTHS_MS,
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch {
    // ignore storage errors
  }

  // Best-effort POST to backend; silently fall through on failure
  try {
    fetch("http://localhost:8000/consent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(consent),
    }).catch(() => {});
  } catch {
    // ignore
  }
  return consent;
}

export function clearConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch {
    // ignore
  }
}

// Tracking loader gated on consent. Actual provider scripts are out of scope.
export function loadTracking() {
  const consent = readConsent();
  if (!consent) return false;
  if (consent.analyse) {
    // placeholder - load analytics provider here
    // e.g. window._paq = window._paq || [];
  }
  if (consent.marketing) {
    // placeholder - load marketing pixels here
  }
  return true;
}
